// @flow
import React, { Fragment } from 'react';

import { t } from 'Src/i18n';
import { FormikInput as Field } from 'Components/frameworks/formik/FormikInput';

import { COMPANION_GROUPS } from './PrebookingForm.constants';
import {
  getKidFutureBithdateValidator,
  getAdultBirthdateValidator,
  type FormFieldOption,
} from './PrebookingForm.utils';

type PrebookingFormCompanionProps = {
  civilities: Array<FormFieldOption>,
  companionGroup: 'adults' | 'kids',
  dateFormat: string,
  hasUnicodeFields: boolean,
  index: number,
};

export const PrebookingFormCompanion = (props: PrebookingFormCompanionProps) => {
  const { companionGroup, dateFormat, hasUnicodeFields, index, civilities } = props;
  const formHeader =
    companionGroup === COMPANION_GROUPS.ADULTS
      ? `${t('prebookingForm.pax.adultCompanionLabel')} ${index + 1}`
      : `${t('prebookingForm.pax.childCompanionLabel')} ${index + 1}`;

  const isRequiredForAdults = companionGroup === COMPANION_GROUPS.ADULTS;
  const isRequiredForKids = companionGroup === COMPANION_GROUPS.KIDS;
  return (
    <div className="flex flex-wrap">
      <p className="w-full mb-2 px-2 text-base font-bold">{formHeader}</p>
      <div className="w-full">
        <div className="w-full md:w-1/2 p-2">
          <Field
            dataTestId={`${companionGroup}-${index}-civility-field`}
            isRequired={isRequiredForAdults}
            name={`${companionGroup}.${index}.civility`}
            options={civilities}
            placeholder={`${t('prebookingForm.mainTraveler.civilityPlaceholder')}${
              isRequiredForAdults ? '*' : ''
            }`}
            type="select"
          />
        </div>
      </div>
      <div className="w-full md:w-1/2 p-2">
        <Field
          dataTestId={`${companionGroup}-${index}-firstName-field`}
          isRequired
          name={`${companionGroup}.${index}.firstName`}
          optimized
          placeholder={`${t('prebookingForm.mainTraveler.firstNamePlaceholder')}*`}
          type="text"
        />
      </div>
      <div className="w-full md:w-1/2 p-2">
        <Field
          dataTestId={`${companionGroup}-${index}-lastName-field`}
          isRequired
          name={`${companionGroup}.${index}.lastName`}
          optimized
          placeholder={`${t('prebookingForm.mainTraveler.lastNamePlaceholder')}*`}
          type="text"
        />
      </div>
      {hasUnicodeFields && (
        <Fragment>
          <div className="w-full md:w-1/2 p-2">
            <Field
              dataTestId={`${companionGroup}-${index}-firstNameUnicode-field`}
              name={`${companionGroup}.${index}.firstNameUnicode`}
              optimized
              placeholder={t('prebookingForm.mainTraveler.firstNameUnicodePlaceholder')}
              type="text"
            />
          </div>
          <div className="w-full md:w-1/2 p-2">
            <Field
              dataTestId={`${companionGroup}-${index}-lastNameUnicode-field`}
              isRequired
              name={`${companionGroup}.${index}.lastNameUnicode`}
              optimized
              placeholder={t('prebookingForm.mainTraveler.lastNameUnicodePlaceholder')}
              type="text"
            />
          </div>
        </Fragment>
      )}
      <div className="w-full md:w-1/2 p-2">
        <Field
          dataTestId={`${companionGroup}-${index}-birthdate-field`}
          isRequired={isRequiredForKids}
          label={t('prebookingForm.mainTraveler.birthDateInformation')}
          name={`${companionGroup}.${index}.birthdate`}
          placeholder={`${t('prebookingForm.mainTraveler.birthDateInformation')}${
            isRequiredForKids ? '*' : ''
          }}`}
          type="birthdate"
          dayPlaceholder="DD"
          monthPlaceholder="MM"
          yearPlaceholder="YYYY"
          dateFormat={dateFormat}
          validate={
            isRequiredForKids ? getKidFutureBithdateValidator() : getAdultBirthdateValidator()
          }
        />
      </div>
    </div>
  );
};
